import R from "ramda";
import { store } from "store";
import { setFlashGenericErrorAction, setFlashMessageAction } from "actions/app-actions";
import {
  createCategory,
  deleteIncludeRule,
  deleteCategories,
  fetchCategories,
  saveCategory,
  createIncludeRules
} from "api/categories";
import { trackEventAction } from "actions/shared/tracking-actions";

export const CREATE_CATEGORY = "actions/categories/create-category";
export const SET_ADD_CATEGORY_VISIBILITY = "actions/categories/set-add-category-visibility";
export const UPDATE_NEW_CATEGORY_NAME = "actions/categories/update-new-category-name";
export const REMOVE_INCLUDE_RULE = "actions/categories/remove-include-rule";
export const SELECT_CATEGORIES = "actions/categories/select-categories";
export const DESELECT_CATEGORIES = "actions/categories/deselect-categories";
export const DELETE_CATEGORIES_LOADING = "actions/categories/delete-categories-loading";
export const DELETE_CATEGORIES_LOADING_STOP = "actions/categories/delete-categories-loading-stop";
export const RELOAD_CATEGORIES = "actions/categories/reload-categories";
export const FOCUS_CATEGORY = "actions/categories/focus-category";
export const UNFOCUS_CATEGORY = "actions/categories/unfocus-category";
export const UPDATE_CATEGORY_NAME = "actions/categories/update-category-name";
export const REMOVE_DROPDOWN_RULE = "actions/categories/remove-dropdown-rule";
export const UPDATE_INCLUDE_VENDORS = "actions/categories/update-include-vendors";
export const SET_DELETE_CATEGORIES_VISIBILITY = "actions/categories/set-delete-categories-visibility";
export const SAVE_CATEGORY_LOADING = "actions/categories/save-category-loading";
export const SAVE_CATEGORY_LOADING_STOP = "actions/categories/save-category-loading-stop";
export const ORDER_CATEGORIES = "actions/categories/order-categories";

const reloadCategories = (accountId, dispatch) => {
  setTimeout(() => {
    fetchCategories(accountId)
      .then(({ categories }) => {
        dispatch({
          type: RELOAD_CATEGORIES,
          data: { categories }
        });
      });
  }, 0);
};

export const createCategoryAction = (accountId, newCategory) => (dispatch) => {
  createCategory(accountId, newCategory)
    .then((response) => {
      dispatch({
        type: CREATE_CATEGORY,
        data: response.data
      });
      dispatch(trackEventAction("Category created"));
    })
    .catch(() => dispatch(setFlashGenericErrorAction()));
};

export const setAddCategoryVisibilityAction = (visibility) => ({
  type: SET_ADD_CATEGORY_VISIBILITY,
  data: { visibility }
});

export const updateNewCategoryNameAction = (name) => ({
  type: UPDATE_NEW_CATEGORY_NAME,
  data: { name }
});

export const removeIncludeRuleAction = (accountId, categoryId, ruleId) => (dispatch) => {
  deleteIncludeRule(accountId, categoryId, ruleId)
    .then(() => {
      dispatch({
        type: REMOVE_INCLUDE_RULE,
        data: { categoryId, ruleId }
      });
      dispatch(trackEventAction("Include rule removed"));
      dispatch(setFlashMessageAction("Rule removed", "error"));
    });
};

export const selectCategoriesAction = (categoryIds) => ({
  type: SELECT_CATEGORIES,
  data: { categoryIds }
});

export const deselectCategoriesAction = (categoryIds) => ({
  type: DESELECT_CATEGORIES,
  data: { categoryIds }
});

export const deleteCategoriesAction = () => (dispatch) => {
  dispatch({ type: DELETE_CATEGORIES_LOADING });
  const state = store.getState();
  const account = state.app.selectedAccount;
  const categoryIds = R.path(["categories", "selectedCategoryIds"], state);

  return deleteCategories(account.id, categoryIds)
    .then(() => {
      reloadCategories(account.id, dispatch);
      dispatch({ type: DELETE_CATEGORIES_LOADING_STOP });
      dispatch(trackEventAction("Category deleted"));
    })
    .catch(() => {
      dispatch(setFlashMessageAction("Oops! Something went wrong. Please try again later", "error"));
      dispatch({ type: DELETE_CATEGORIES_LOADING_STOP });
    });
};

export const focusCategoryAction = (category, style) => ({
  type: FOCUS_CATEGORY,
  data: { category, style }
});

export const unfocusCategoryAction = () => ({
  type: UNFOCUS_CATEGORY
});

export const updateCategoryNameAction = (name) => ({
  type: UPDATE_CATEGORY_NAME,
  data: { name }
});

export const updateIncludeVendorsAction = (vendor) => ({
  type: UPDATE_INCLUDE_VENDORS,
  data: { vendor }
});

export const removeDropdownRuleAction = (rule, isNew = false) => (dispatch) => {
  dispatch({
    type: REMOVE_DROPDOWN_RULE,
    data: { rule, isNew }
  });
};

export const setDeleteCategoriesVisibilityAction = (visibility) => ({
  type: SET_DELETE_CATEGORIES_VISIBILITY,
  data: { visibility }
});

export const saveCategoryChangesAction = (data) => (dispatch) => {
  dispatch({ type: SAVE_CATEGORY_LOADING });
  createIncludeRules(data.accountId, data.focusedCategory.id, data.newIncludeRules)
    .then(() => saveCategory(data.accountId, data.focusedCategory))
    .then(() => dispatch(setFlashMessageAction("Category Saved")))
    .then(() => reloadCategories(data.accountId, dispatch))
    .then(() => dispatch({ type: SAVE_CATEGORY_LOADING_STOP }))
    .catch(() => dispatch(setFlashMessageAction("Oops! Something went wrong. Please try again later", "error")));
};

export const orderCategoriesAction = (column) => ({
  type: ORDER_CATEGORIES,
  data: { column }
});



// WEBPACK FOOTER //
// ./src/js/actions/categories-actions.js